import React, {useMemo} from 'react';
import ProgressBar from "react-bootstrap/ProgressBar";
import styles from "components/loyaltyBadges/loyaltyPoints/styles";
import classnames from "classnames";
import {ReactComponent as LoyaltyBadgeSvg} from 'resources/images/loyalty-badge.svg';
import {useTheme} from "react-jss";
import {NumericFormat} from "react-number-format";
import {FormattedMessage} from "react-intl";


/**
 *
 * @param {Object} props
 * @param {JSX.Element} props.icon
 * @param {JSX.Element} props.primaryText
 * @param {JSX.Element} props.secondaryText
 * @param {number} props.availableBalance
 * @param {number} props.initialBalance
 * @returns {JSX.Element}
 */
function LoyaltyPoints(props) {
  const {availableBalance, initialBalance} = props;
  const theme = useTheme();
  const classes = styles({theme});

  const currentProgress = useMemo(() => {
    let result = (availableBalance / initialBalance) * 100;

    if (result && !isNaN(result))
      return result;

    return 0;
  }, [availableBalance, initialBalance]);


  return (
    <div className={classnames('loyalty-points', classes.loyaltyPoints)}>
      <div className={classes.loyaltyPointsIconContainer}>
        <LoyaltyBadgeSvg/>
      </div>
      <div className={classnames(classes.loyaltyPointInfo)}>
        <NumericFormat
          value={initialBalance}
          thousandSeparator=","
          fixedDecimalScale
          displayType="text"
          renderText={(points) => <h6 className={classes.loyaltyPointsText}><FormattedMessage id="loyalty.card.points" values={{points}}/></h6>}
        />
        <ProgressBar now={currentProgress} className={classes.loyaltyPointProgress}/>
        <NumericFormat
          value={availableBalance}
          thousandSeparator=","
          fixedDecimalScale
          displayType="text"
          renderText={(points) => <p className={classes.loyaltyPointsText}><FormattedMessage id="loyalty.card.pointsRemaining" values={{points}}/></p>}
        />
      </div>
    </div>
  );
}

export default LoyaltyPoints;